import { conversationAddressTypes } from 'redux_new/conversations/types'
import apiUsers from 'api/users'

/**
 * Display container
 * @param {String} userId
 * @param {Boolean} isOpen
 * @param {Boolean} [isLoading=false]
 */
const display = (userId, isOpen, isLoading = false) => ({
  type: conversationAddressTypes.display,
  isOpen,
  userId,
  isLoading,
})

/**
 * Update user address
 * @param {String} userId
 * @param {Object} [address=null]
 */
const update = (userId, address = null) => ({
  type: conversationAddressTypes.update,
  userId,
  address,
})

/**
 * Close collapse for an user
 */
const close = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  dispatch(display(activeUser, false))
}

/**
 * Get an user's address
 */
const get = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  dispatch(display(activeUser, true, true))

  try {
    const { data, status } = await apiUsers.address.get(activeUser)

    if (status === 200) {
      dispatch(update(activeUser, data.results || null))
    }
  } catch (error) {
    console.error('Error status:', error.status, 'data:', error.data || error.message)
  }

  dispatch(update(activeUser))
}

/**
 * Add or update an user's address
 * @param {object} newAddress
 */
const set = (newAddress) => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  try {
    const { data, status } = await apiUsers.address.update(activeUser, newAddress)

    if (status !== 200) throw new Error({ status, data })

    dispatch(update(activeUser, newAddress))

    return true
  } catch (error) {
    console.error('Error status:', error.status, 'data:', error.data || error.message)

    throw new Error({ message: error.message || error.data })
  }
}

export default {
  close,
  get,
  set,
}
